import React from "react";
import Card from "./Card";
import ScrollToTop from "./utils/ScrollToTop";

function SubmissionErrorCard({ error }) {
  return (
    <React.Fragment>
      <ScrollToTop />
      <Card title="Sorry, that didn’t work" removeTopPadding>
        {error}
      </Card>
    </React.Fragment>
  );
}

export default SubmissionErrorCard;
